import { AsyncPipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  input,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';
import { BtnIconComponent } from '../buttons/btn-icon/btn-icon.component';
import { BtnTextComponent } from '../buttons/btn-text/btn-text.component';

@Component({
  selector: 'list-utils-bar',
  standalone: true,
  imports: [
    BtnTextComponent,
    BtnIconComponent,
    AsyncPipe,
    FormsModule,
    BtnIconComponent,
  ],
  templateUrl: './list-utils-bar.component.html',
  styleUrl: './list-utils-bar.component.css',
})
export class ListUtilsBarComponent {
  logger: NGXLogger = inject(NGXLogger);
  searchDisabled = input<boolean>(false);
  advancedSearchEnabled = input<boolean>(false);
  @Input() isSearching = of(false);
  @Input() showingResults = of(false);
  @Output() onSearch = new EventEmitter<string>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onRefresh = new EventEmitter<void>();
  @Output() onAdvancedSearch = new EventEmitter<void>();
  @Output() onCancelAdvancedSearch = new EventEmitter<void>();
  @Output() onFilter = new EventEmitter<void>();
  @Output() valueChanged = new EventEmitter<string>();

  searchTerm: string = '';

  showAdvancedSearch$: Observable<boolean> = of(false);

  onSearchClick() {
    const term = this.searchTerm.trim() || '';
    if (!term || term === '') return;
    this.onSearch.emit(term);
  }

  onCancelClick() {
    this.searchTerm = '';
    this.onCancel.emit();
  }

  onValueChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchTerm = input.value;
    this.valueChanged.emit(input.value);
  }

  onAdvSrch() {
    this.showAdvancedSearch$ = of(true);
    this.onAdvancedSearch.emit();
  }

  cancelAdvSrch() {
    this.showAdvancedSearch$ = of(false);
    this.onCancelAdvancedSearch.emit();
  }

  refresh() {
    this.onRefresh.emit();
  }
}
